import { render, staticRenderFns } from "./CompanyAdditionalDataUnstructured.vue?vue&type=template&id=978988da&scoped=true&"
import script from "./CompanyAdditionalDataUnstructured.vue?vue&type=script&lang=ts&"
export * from "./CompanyAdditionalDataUnstructured.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyAdditionalDataUnstructured.vue?vue&type=style&index=0&id=978988da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978988da",
  null
  
)

export default component.exports